import { Permission } from '@/lib/permissions/v1'
import { logParamKey, Route } from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'created_at',
        direction: 'desc',
    })

    //route.setLimit(40)
}

export enum LogsRouteName {
    Index = 'logs.index',
    Details = 'logs.details',
}

export default {
    path: '/logs',
    component: () => import('@/views/logs/Index.vue'),
    children: [
        {
            path: `:${logParamKey}`,
            name: LogsRouteName.Details,
            component: () => import('@/views/logs/details/Index.vue'),
            meta: {
                label: 'Log Details',
                auth: true,
                permission: Permission.EventView,
            },
        },
    ],
}
